import { useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import LoginPage from "@/pages/LoginPage";
import InviteAcceptPage from "@/pages/InviteAcceptPage";
import HomePage from "@/pages/HomePage";
import OrganizationsPage from "@/pages/OrganizationsPage";
import OrganizationDetailPage from "@/pages/OrganizationDetailPage";
import InvitationsPage from "@/pages/InvitationsPage";
import AdAccountsPage from "@/pages/AdAccountsPage";
import AdAccountDetailPage from "@/pages/AdAccountDetailPage";
import CampaignDetailPage from "@/pages/CampaignDetailPage";
import AdSetDetailPage from "@/pages/AdSetDetailPage";
import NotFoundPage from "@/pages/NotFoundPage";
import RequireAuth from "@/app/RequireAuth";
import RequireRole from "@/app/RequireRole";
import AuthLayout from "@/app/AuthLayout";

export default function App() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onExpired = () => {
      if (location.pathname.startsWith("/login") || location.pathname.startsWith("/invite/")) return;
      toast.error("登录已过期，请重新登录");
      navigate(`/login?next=${encodeURIComponent(location.pathname + location.search)}`, {
        replace: true,
      });
    };
    window.addEventListener("auth:expired", onExpired);
    return () => window.removeEventListener("auth:expired", onExpired);
  }, [navigate, location]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/invite/accept" element={<InviteAcceptPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<AuthLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/ad-accounts" element={<AdAccountsPage />} />
          <Route path="/ad-accounts/:id" element={<AdAccountDetailPage />} />
          <Route path="/ad-accounts/:accountId/campaigns/:campaignId" element={<CampaignDetailPage />} />
          <Route path="/ad-accounts/:accountId/adsets/:adsetId" element={<AdSetDetailPage />} />

          <Route element={<RequireRole min="ORG_ADMIN" />}>
            <Route path="/invitations" element={<InvitationsPage />} />
          </Route>

          <Route element={<RequireRole min="SUPER_ADMIN" />}>
            <Route path="/organizations" element={<OrganizationsPage />} />
            <Route path="/organizations/:id" element={<OrganizationDetailPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
